import { render, staticRenderFns } from "./wf-dynamic-list-textarea-and-filled-radio-buttons-display.vue?vue&type=template&id=147b9c6c&scoped=true&"
import script from "./wf-dynamic-list-textarea-and-filled-radio-buttons-display.vue?vue&type=script&lang=ts&"
export * from "./wf-dynamic-list-textarea-and-filled-radio-buttons-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-dynamic-list-textarea-and-filled-radio-buttons-display.vue?vue&type=style&index=0&id=147b9c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b9c6c",
  null
  
)

export default component.exports